import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import {
  Box,
  Button,
  Card,
  Chip,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import FromAndToDatePicker from "../../../components/mui/FromAndToDatePicker";
import dayjs from "dayjs";
import {
  getRescheduledcounts,
  getTutoReplacedData,
} from "../../../redux/features/srtSlice";
import Trcoursecard from "./TrtCourseCard";
import Iconify from "../../../components/Iconify";
import TrtrankCard from "./TrtrankCard";

const TrDashboard = () => {
  const [fromDate, setFromDate] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    dayjs().endOf("month").format("YYYY-MM-DD")
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { tutorReplacedData, loading } = useSelector((state) => state.srt);

  useEffect(() => {
    dispatch(
      getTutoReplacedData({
        fromDate: fromDate,
        toDate: toDate,
      })
    );
  }, [fromDate, toDate]);

  const handlenavigate = useCallback((projectId) => {
    navigate(
      `/my-workspace/trt-croview?fromDate=${fromDate}&toDate=${toDate}&projectId=${projectId}`
    );
  });

  const handlenavigateTA = useCallback((projectId) => {
    navigate(
      `/my-workspace/trt-tawiseview?fromDate=${fromDate}&toDate=${toDate}&projectId=${projectId}`
    );
  });

  return (
    <GlobalWrapper title={"Tutor Replacements"}>
      <Box sx={{ display: "flex", mb: 1 }}>
        <FromAndToDatePicker
          disabled={false}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
      </Box>
      <Box
        sx={{
          paddingTop: 2,
        }}
      >
        <Grid container spacing={2}>
          {tutorReplacedData?.map((data, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Trcoursecard
                project={data.projectName}
                replacements={data.replacementCount}
                navigations={
                  <Box
                    sx={{
                      mt: "10px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      sx={{
                        color: "#fff",
                        mb: "10px",
                        borderRadius: "20px",
                        backgroundColor: "none",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        border: "1px solid white",
                        "&:hover": {
                          backgroundColor: "white",
                          color: "#5C374C",
                          border: "1px solid white",
                        },
                      }}
                      size="small"
                      variant="text"
                      onClick={() => handlenavigate(data.projectId)}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          px: "2px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="button" sx={{ color: "inherit" }}>
                          CRM View
                        </Typography>
                        <Iconify
                          icon={"mdi:eye"}
                          color="inherit"
                          width={35}
                          height={35}
                        />
                      </Box>
                    </Button>
                    <Button
                      sx={{
                        color: "#fff",
                        borderRadius: "20px",
                        backgroundColor: "none",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        border: "1px solid white",
                        "&:hover": {
                          backgroundColor: "white",
                          color: "#5C374C",
                          border: "1px solid white",
                        },
                      }}
                      size="small"
                      variant="text"
                      onClick={() => handlenavigateTA(data.projectId)}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          px: "2px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="button" sx={{ color: "inherit" }}>
                          TA View
                        </Typography>
                        <Iconify
                          icon={"mdi:eye"}
                          color="inherit"
                          width={35}
                          height={35}
                        />
                        <Typography sx={{ fontWeight: 600 }}>
                          {/* {data.student_reason} */}
                        </Typography>
                      </Box>
                    </Button>
                  </Box>
                }
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </GlobalWrapper>
  );
};

export default TrDashboard;
